module.exports = __webpack_public_path__ + "cat_img2.png?148e5bac6fe8e97bcbb7f4376d248df4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cat_img2.png
// module id = 254
// module chunks = 0